import { IAuthAccount } from "../src/taskpane/interfaces/IAuthTokenResultDto";
import { apiClientError, apiLog } from "../src/taskpane/services/ApiService";
import AuthModule from "./AuthModule";

export const logger = async (e: Error, filePath: string, additionalData?: string) => {
    console.error(e);
    let account: IAuthAccount;
    let hostType: string;
    let error: Error;
    let path: string = filePath;
    try {
        if (typeof Office !== "undefined") {
            switch (Office.context?.diagnostics?.host) {
                case Office.HostType.Word:
                    hostType = "Word";
                    break;
                case Office.HostType.Excel:
                    hostType = "Excel";
                    break;
                case Office.HostType.PowerPoint:
                    hostType = "PowerPoint";
                    break;
                case Office.HostType.Outlook:
                    hostType = "Outlook";
                    break;
                default:
                    hostType = "Other";
                    break;
            }
        }
        else {
            hostType = "Other";
        }

        account = await AuthModule.getAccount();
        error = e;
    } catch (err) {
        error = err;
        path = "logger.ts";
    }

    let errorMessage: string = error?.message + (additionalData ? ` - ${additionalData}` : "") + (error?.stack ? ` Stack: ${error.stack}` : "");
    if (error && (errorMessage === undefined || !errorMessage)) {
        try {
            errorMessage = JSON.stringify(error);
        } catch (error) {
            // ignore
        }
    }

    const clientError = {
        error: errorMessage,
        filePath: path,
        accountId: account?.accountId,
        browser: navigator?.userAgent,
        hostType: hostType,
    }

    try {
        await apiClientError(clientError);
    } catch (error) {
        console.error("Error on log save: ", error);
    }
}

export const logMessage = async (message: string, type?: string) => {
    try {
        const account: IAuthAccount = await AuthModule.getAccount();
        await apiLog(message, account, type);
    } catch (error) {
        console.error("Error on log message: ", error);
    }
}